import { AsyncValidator, AbstractControl, ValidationErrors } from "@angular/forms";
import { Observable } from "rxjs";
import { Deferred } from "../helpers/deferred";
import { OperationCanceledException } from "../exceptions/operation-canceled-exception";

export abstract class BaseAsyncValidator implements AsyncValidator {
    
    protected _onChange: () => void;

    protected get validatorKey(): string {
            return this._validatorKey;
    }

    private _cancellation: Deferred;
    private _validatorKey: string;

    constructor(validatorKey: string) {
            this._validatorKey = validatorKey;
    }

    public readonly validate = (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
            return this.validateInternalAsync(control);
    };

    public readonly registerOnValidatorChange = (fn: () => void): void => { this._onChange = fn; };

    protected abstract getValidationResultAsync(control: AbstractControl, cancellationToken: Promise<any>): Promise<ValidationErrors | null>;

    protected buildValidationErrorResult(result: any): ValidationErrors {
            const error: ValidationErrors = {};

        error[this._validatorKey] = result;

        return error;
    }

    private async validateInternalAsync(control: AbstractControl): Promise<ValidationErrors | null> {
            if (this._cancellation) {
                this._cancellation.resolve();
        }

        const cancellation = new Deferred();
        this._cancellation = cancellation;

        try {
                const result = await this.getValidationResultAsync(control, cancellation.promise());

            if(result){
                    control.markAsTouched();
            }

            return result;
        }
        catch (e) {
                if (e instanceof OperationCanceledException) {
                    return null;
            }

            control.markAsTouched();

            return this.buildValidationErrorResult({ error: e });
        }
    }
}